import clsx from 'clsx'
import React from 'react'

import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'

const root = css`
  width: ${spacing(6)};
  height: ${spacing(6)};
  background-color: ${cssTheme.default.day.control};
  border-radius: ${spacing(1.5)};
  overflow: hidden;
  position: relative;

  &:before,
  &:after {
    content: '';
    position: absolute;
    width: 50%;
    height: 50%;
    bottom: 0;
  }

  &:before {
    left: 0;
    background-color: ${cssTheme.default.day.backgroundMinor};
  }

  &:after {
    right: 0;
    background-color: ${cssTheme.default.day.text};
  }
`

const YandexGoLogo: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({className, ...props}) => {
  return <div className={clsx(root, className)} {...props} />
}

export default YandexGoLogo
